<template>
    <div>
        <v-modal-contents ref="modal_contents_agree">
            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title mt-30 pl-3 ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn_bordered "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>

        <v-form ref="form" class="form_upload form-career-new pr-2" v-model="valid" lazy-validation>

            <div class="form-career-new__wrapper position-relative">
                <div class="form-career-new__top">
                </div>
                <img class="form-career-new__img" src="/local/templates/international/img/form-bg.png" alt="">
                <img class=" form-career-new__img--medium" src="/local/templates/international/img/form-bg-2.png"
                     alt="">
                <img class=" form-career-new__img--small" src="/local/templates/international/img/form-bg-3.png" alt="">
            </div>
            <div class="row mx-0 my-0">
                <div class="col-12 pb-4 px-4 pt-4">
                    <div class="form_upload__item">

                        <v-text-field
                                      v-model="name"
                                      :rules="[rules.required, rules.ruleTownName]"
                                      required=""
                                      class="form__input"
                                      id="name"
                        >

                            <template v-slot:label>
                                ФИО
                            </template>
                        </v-text-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 pb-4 px-4 pt-4">
                    <div class="form_upload__item item_tel position-relative">
                        <v-text-field
                                v-model="tel_input"
                                :rules="tel_inputRulesRu"
                                required
                                id="tel"
                                oninput="this.value = this.value.replace(/^\(8/, '(');"
                                class="pl-0 form__input"
                                max="20"
                                v-mask="'# ### ###-##-##'"
                        >

                            <template v-slot:label>
                                Телефон
                            </template>
                        </v-text-field>
                    </div>
                </div>

                <div class="col-12 col-md-6 pb-4 px-4 pt-4">
                    <div class="form_upload__item">
                        <v-text-field class="form__input"
                                      v-model="email"
                                      :rules="[rules.mail]"
                                      required
                                      oninput="this.value = this.value.trim()"
                                      id="email"
                        >
                            <template v-slot:label>
                                Электронная почта
                            </template>
                        </v-text-field>

                    </div>
                </div>

                <div class="col-12 col-md-6 pb-4 px-4 pt-4">
                    <div class="form_upload__item directionСoop">
                        <v-text-field
                                v-model="country"
                                :rules="[rules.required]"
                                required
                                class="form__input"
                                id="company"

                        >
                            <template v-slot:label>
                                Страна
                            </template>
                        </v-text-field>
                    </div>
                </div>

                <div class="col-12 col-md-6 pb-4 px-4 pt-4">
                    <div class="form_upload__item">
                        <v-text-field
                                v-model="town"
                                :rules="[rules.required, rules.ruleTownName]"
                                required
                                class="form__input"
                                id="company"

                        >
                            <template v-slot:label>
                                Город
                            </template>
                        </v-text-field>
                    </div>
                </div>

                <div class="col-12 col-md-12 pb-4 px-4 pt-4 pr-4">
                    <div class="form_upload__item ">
                        <div
                                class="summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center"
                                @dragover="dragover"
                                @dragleave="dragleave"
                                @drop="drop"
                                id="summary"
                        >
                            <input
                                    type="file"
                                    multiple
                                    name="fields[assetsFieldHandle][]"
                                    id="assetsFieldHandle"
                                    class="w-px h-px opacity-0 overflow-hidden absolute"
                                    @change="onChange"
                                    ref="file"
                                    accept=".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx"
                            />

                            <label for="assetsFieldHandle" class="block cursor-pointer">
                                <div>Выберите или перетащите сюда файл в формате PDF, DOC, DOCX,
                                    RTF, JPG
                                </div>
                            </label>
                            <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                                <li class="text-sm p-1 text-left" v-for="(file, index) in filelist" :key="index">
                                    {{ file.name }}
                                    <button
                                            class="ml-2 remove_file"
                                            type="button"
                                            @click="remove(filelist.indexOf(file))"
                                            title="Remove file"
                                    >
                                        Удалить
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-12 pb-6 px-4 pt-4">
                    <!-- SmartCaptcha -->
                    <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                         class="w-100 mt-30 pl-2"></div>
                    <div class="form_upload__item  mt-30">
                        <v-checkbox
                                v-model="checkbox"
                                :rules="[(v) => !!v || 'Это обязательный пункт']"
                                required
                                color="red"
                        >
                            <template v-slot:label>
                                <div class="customLabelForm">
                                    Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                                            @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                    использования</a> моих персональных данных для обработки данного обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с
                                    <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">Политикой
                                        конфиденциальности</a> и <a :href="agreement" @click="linkOpen(agreement)"
                                                                    class="position-relative zi-1">Пользовательским
                                    соглашением.</a>
                                </div>
                            </template>
                        </v-checkbox>

                        <!--            :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                        <!--            required-->
                        <v-checkbox
                                v-model="consentToInform"

                                color="red"
                                class="mt-0"
                        >
                            <template v-slot:label>
                                <div class="customLabelForm">
                                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                                    партнеров.
                                </div>
                            </template>
                        </v-checkbox>

                        <div class="btn_form d-flex align-items-center justify-content-end ">
                            <v-btn  :disabled="!valid" class="px-30 btn_red w-mc"
                                   @click="sendForm">
                                Отправить
                            </v-btn>

                            <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                            <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                        </div>
                    </div>

                </div>


            </div>

        </v-form>
    </div>

</template>
<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
    components: {
        VModalContents: VModalContents,
    },
    directives: {mask},
    name: "formCareerNew",
    props: {
        // lang: Array | String | Number | Boolean | Object,
        directions: Array | String | Number | Boolean | Object,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    delimiters: ["${", "}"], // Avoid Twig conflicts
    data() {
        return {
            captchaPassed: false,

            valid: true,


            rules: {
                required: value => !!value || 'Обязательное поле',

                ruleTownName: value => {
                    const patternSp = /[~`!@№#$%^&*()+={}\[\];:\'\"<>.,]|[0-9_]/g
                    return !patternSp.test(value) || 'Неккоректный ввод'
                },

                mail: value => {
                    const pattern = /^(([^<>()[\]\\{\/№%^!#/$?*~+=.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Неккоректная электронная почта'
                },

                phone: value => {
                    const pattern = /^\+?[1-9][0-9]{7,14}$/
                    return pattern.test(value) || 'Некорректный телефон'
                }
            },
            name: "",
            nameRules: [
                (v) => !!v || "Name is required",
                (v) => (v && v.length >= 3) || "Name must be less than 10 characters",
            ],

            nameRulesRu: [
                (v) => !!v || "Поле 'ФИО' не может быть пустым",
                (v) => (v && v.length >= 3) || "Поле 'ФИО' не может быть меньше 3 символов",
            ],

            email: "",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],

            emailRulesRu: [
                (v) => !!v || "E-mail обязателен",
                (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
            ],


            town: "",
            country: "",

            tel_input: "",

            tel_inputRulesRu: [
                (v) => !!v || "Поле 'Телефон' обязательно к заполнению",
                // (v) => /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(v) || "Поле 'Телефон' заполнено неправильно",
            ],

            checkbox: false,
            consentToInform: false,

            // upload drag-and-drop file
            filelist: [],
        };
    },

    methods: {

        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        sendForm() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
            /** AJAX */
            var VueObject = this;
            var formData = new FormData();
            $.each(VueObject.filelist, function (key, value) {
                formData.append(key, value);
            });

            let newTel = VueObject.tel_input;
            if (newTel[0] === '7') {
                newTel = "+ " + newTel; // если первая цифра 7, добавляем +
            }
            console.log(newTel);

            //formData.append("direction", VueObject.directionСoopRu[VueObject.select_directionСoop]);
            formData.append("name", VueObject.name);
            formData.append("phone", newTel);
            formData.append("email", VueObject.email);
            formData.append("town", VueObject.town);
            formData.append("country", VueObject.country);
            formData.append("ajaxPost", "Y");
            console.log(formData);
            $.ajax({
                "type": "POST",
                "url": "/ajax/career_form.php",
                "data": formData,
                "cache": false,
                "dataType": 'json',
                "processData": false, // Не обрабатываем файлы (Don't process the files)
                "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
                "success": function (res) {
                    console.log(res);
                    $(".text_result").slideDown(300);
                    $(".text_result").delay(3000).slideUp(300);
                    VueObject.$refs.form.reset();
                    setTimeout(function () {
                        window.location.reload()
                    }, 3000);
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },

        // upload drag-and-drop file

        onChange() {
            this.filelist = [...this.$refs.file.files];
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },

        // upload drag-and-drop file end
    },
    created() {
        setTimeout(() => {
            this.initCaptcha();
        }, 500)
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }
};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";

.wrapp_cooperation.v-menu__content {
  margin-top: 51px;
}

.form-career-new {
  box-shadow: 0px 4px 8px 0px #0000000F;
  border: 1px solid #F2F2F2;
  border-radius: 20px;
  margin-bottom: 30px;

  @media(max-width: 576px) {
    margin-top: 10px;
  }

  &__wrapper {
    padding: 20px 20px 20px 25px;
  }

  &__top {
    position: absolute;
    top: 20px;
    left: 20px;
    max-width: 745px;
    width: 100%;
    padding: 40px;

    @media (max-width: 980px) {
      max-width: 400px;
      padding: 20px;
    }
    @media (max-width: 768px) {
      max-width: 95%;
    }

    @media (max-width: 500px) {
      padding: 40px;
    }

    @media (max-width: 360px) {
      padding: 20px;
    }
  }

  &__title {
    font-size: 48px;
    font-weight: 400;
    line-height: 58px;
    text-align: left;
    color: #4B4C4E;
    font-family: "MuseoSansCyrl-600";

    @media (max-width: 980px) {
      font-size: 38px;
      line-height: 44px;
    }


    @media (max-width: 768px) {
      font-size: 38px;
      line-height: 44px;
    }

    @media (max-width: 650px) {
      font-size: 28px;
      line-height: 34px;
    }

    & > span {
      color: #FF4237;
    }
  }

  &__desc {
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    color: #4B4C4E;
    margin-top: 25px;


    @media (max-width: 980px) {
      font-size: 16px;
      line-height: 20px;
    }

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 24px;
    }

    @media (max-width: 650px) {
      font-size: 16px;
      line-height: 22px
    }
    @media (max-width: 360px) {
      display: none;
    }
  }


  &__img {
    border-radius: 20px;
    width: 100%;
    height: auto;
    object-fit: cover;
    z-index: -1;

    @media (max-width: 768px) {
      display: none;
    }

    &--medium {
      display: none;
      border-radius: 20px;
      width: 100%;
      height: auto;
      object-fit: cover;
      z-index: -1;

      @media (max-width: 768px) {
        display: block;
      }
      @media (max-width: 500px) {
        display: none;
      }
    }

    &--small {
      display: none;
      border-radius: 20px;
      width: 100%;
      height: auto;
      object-fit: cover;
      z-index: -1;

      @media (max-width: 500px) {
        display: block;
      }
    }
  }

  & .form_upload__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }


  & .form_upload .theme--light.v-btn.v-btn--has-bg[disabled="disabled"] {
    background: radial-gradient(50% 50% at 50% 50%, rgb(176 176 176 / 80%) 0%, #c1b8b8 100%) !important;

    & .v-btn__content {
      color: white;
    }
  }

  & .form_upload__item ul {
    list-style: none;
    margin-left: 22px;
  }

  & .form_upload__item label {

    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #656565;
  }

  & .v-text-field__details {
    transform: translate(-10px, 15px);
  }

  & .v-label--active {
    //top: 15px !important;
  }

  & form.form_upload {
    box-sizing: border-box;
    border: 1px solid rgb(242, 242, 242);
    border-radius: 30px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
    background: rgb(255, 255, 255);
    padding: 20px 20px;
  }

  & .form_upload .tel_sel__btn {
    width: max-content;
    height: 0;
    position: absolute;
    top: 32px;
    background: none;
    margin-left: 15px !important;
  }

  & .form__input {
    width: auto;
    height: 60px;
    border: 1px solid #E2E2E2;
    box-shadow: 0px 1.5px 4px -1px #0A090B12;
    border-radius: 10px;
    padding: 15px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #282828;
    resize: none;
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  .drag_form {
    background: rgba(249, 66, 55, 0.06);
    border: 1px dashed #f94237 !important;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "RobotoRegular";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    display: flex;
    align-items: center;
    color: #000000;
    opacity: 0.7;
    text-align: center;
  }
}

.v-input.tel_input.form__input.v-input--is-focused .v-label,
.v-input.tel_input.form__input.v-input--is-label-active .v-label--active {
  display: none;
}

.v-list-item {
  @media (max-width: 766px) {
    margin-bottom: 10px;
  }
}
</style>